import {
    Box,
    Heading,
    ListItem,
    Skeleton,
    Text,
    UnorderedList,
    useDisclosure
} from '@chakra-ui/react';
import { DateTime } from 'luxon';

import ExperienceModal from './ExperienceModal';

interface Props {
    isLoaded: boolean;
    profileId: string;
    startDate: string;
    endDate: string;
    title: string;
    description: string;
    employer: string;
    isCurrent: boolean;
}

export default function ExperienceCard({
    employer,
    startDate,
    endDate,
    description,
    isLoaded,
    profileId,
    title,
    isCurrent,
}: Props) {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const formattedDates = formatDates(startDate, endDate, isCurrent);

    const descriptionItems: string[] | undefined = sanitizeDescription(description);

    return (
        <Skeleton isLoaded={isLoaded}>
            <Box
                border="1px solid"
                borderColor="midnight.50"
                borderRadius={{ lg: 'xl' }}
                p="6"
                mb="4"
                backgroundColor="white"
                align='left'
            >
                <Text fontSize="14px" color="midnight.300">
                    {formattedDates}
                </Text>
                <Heading
                    size="md"
                    mb="2"
                    style={{
                        color: 'var(--chakra-colors-midnight-500)',
                        fontWeight: 700
                    }}
                >
                    {employer}
                    {/* {isCurrentUser ? <Button onClick={onOpen}>Edit</Button> : ''} */}
                </Heading>
                <Heading
                    size="sm"
                    mb="2"
                    style={{
                        color: 'var(--chakra-colors-midnight-300)',
                        fontWeight: 300
                    }}
                >
                    {title}
                </Heading>
                <Skeleton isLoaded={descriptionItems !== undefined}>
                    <DescriptionList listItems={descriptionItems} />
                </Skeleton>
            </Box>
            <ExperienceModal
                endDate={endDate}
                isOpen={isOpen}
                onClose={onClose}
                onOpen={onOpen}
                profileId={profileId}
                startDate={startDate}
            />
        </Skeleton>
    );
}

function DescriptionList(props: any) {
    const { listItems } = props;
    if (listItems === undefined) {
        return <div></div>;
    }

    return (
        <UnorderedList>
            {listItems.map((item: string) => {
                if (!item) {
                    return <></>;
                }
                return (
                    <ListItem mb="4" key={item}>
                        {item
                            .replace(/^-/, '')
                            .replace('\u2022', '')
                            .replace('\u00B7', '')
                            .replace('\u25CF', '')
                            .replace('\u27A2', '')
                            .replace('\u25AA', '')}
                    </ListItem>
                );
            })}
        </UnorderedList>
    );
}

function sanitizeDescription(description: string) {
    if (!description) {
        return [];
    }
    return description.match(/<li>(.*?)<\/li>/g)?.map((val) => {
        return val.replace(/\*/g, '').replace(/<[^>]*>?/gm, '');
    });
}

function formatDates(startDate: string, endDate: string, is_current: boolean) {
    const start = DateTime.fromISO(startDate, { setZone: true });
    const end = DateTime.fromISO(endDate, { setZone: true });
    
    const formattedStart = `${start.month}/${start.year}`;
    const formattedEnd = !is_current ? `${end.month}/${end.year}`: "present";
    return `${formattedStart} - ${formattedEnd}`;
}
